import { AiModel } from "~/shared/enums";

export const AI_MODEL_SET = new Set(Object.values(AiModel));

export const AI_MODEL_TO_DISPLAY_NAME: Record<AiModel, string> = {
  [AiModel.GPT_4_1]: "GPT-4.1",
  [AiModel.GPT_4O]: "GPT-4o",
  [AiModel.CLAUDE_3_5_SONNET]: "Claude 3.5 Sonnet",
  [AiModel.CLAUDE_3_7_SONNET]: "Claude 3.7 Sonnet",
  [AiModel.GEMINI_2_5_FLASH]: "Gemini 2.5 Flash",
};
